import React from 'react';
import InovxLoader from '@shared/global/InovxLoader';

const NotFoundPage: React.FC = () => (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
        <h1>{InovxLoader.t('common:pages.notFoundTitle')}</h1>
        <p>{InovxLoader.t('common:pages.notFoundDescription')}</p>
        <a href="/">{InovxLoader.t('common:pages.returnToHome')}</a>
    </div>
);

export default NotFoundPage;
